/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessApiResponse } from '../../models/success-api-response';

export interface DeleteCustomerBeneficiaryAsync$Plain$Params {
  beneficiaryId: number;
  id: number;
}

export function deleteCustomerBeneficiaryAsync$Plain(http: HttpClient, rootUrl: string, params: DeleteCustomerBeneficiaryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteCustomerBeneficiaryAsync$Plain.PATH, 'delete');
  if (params) {
    rb.path('beneficiaryId', params.beneficiaryId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

deleteCustomerBeneficiaryAsync$Plain.PATH = '/api/customer/{id}/beneficiary/{beneficiaryId}';
